module.exports = __webpack_public_path__ + "mercury-logo-669419bb3a2e95f6e0b437123a57a20b.svg";